import { Linkedin, Facebook, Youtube, Mail, Phone } from "lucide-react";
import { ClinivonMark } from "@/components/site/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#061A30] text-white border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14">
        <div className="grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <ClinivonMark size={40} className="ring-white/10" />
              <div>
                <div className="font-display font-bold text-white text-lg tracking-tight">CLINIVON</div>
                <div className="text-[10px] tracking-[0.25em] text-white/50 uppercase">Operational Excellence</div>
              </div>
            </div>
            <p className="mt-5 text-sm text-white/60 leading-relaxed max-w-md">
              Transforming Businesses Through Operational Excellence — Change Management, Continuous Improvement,
              Process Mapping, SOP Development, KPI Development, Contract Evaluation & Review.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Capabilities</div>
            <ul className="space-y-2 text-sm text-white/70">
              <li>Change Management</li>
              <li>Continuous Improvement</li>
              <li>Process Mapping</li>
              <li>SOP & KPI Development</li>
              <li>Contract Evaluation</li>
              <li>Supply Chain Optimization</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[10px] tracking-[0.25em] uppercase text-white/40 mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-center gap-2"><Phone size={14} className="text-[#10B981]" /> 942-995-1975</li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#10B981]" /> <a href="mailto:cs@clinivon.com" className="hover:text-[#10B981] transition-colors">cs@clinivon.com</a> <span className="text-white/40 text-[10px] uppercase tracking-wider">· Support</span></li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#10B981]" /> <a href="mailto:orders@clinivon.com" className="hover:text-[#10B981] transition-colors">orders@clinivon.com</a> <span className="text-white/40 text-[10px] uppercase tracking-wider">· Orders</span></li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#10B981]" /> <a href="mailto:ar@clinivon.com" className="hover:text-[#10B981] transition-colors">ar@clinivon.com</a> <span className="text-white/40 text-[10px] uppercase tracking-wider">· Billing</span></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" aria-label="LinkedIn" className="h-9 w-9 grid place-items-center border border-white/15 hover:border-[#10B981] hover:text-[#10B981] transition-colors"><Linkedin size={14} /></a>
              <a href="#" aria-label="Facebook" className="h-9 w-9 grid place-items-center border border-white/15 hover:border-[#10B981] hover:text-[#10B981] transition-colors"><Facebook size={14} /></a>
              <a href="#" aria-label="YouTube" className="h-9 w-9 grid place-items-center border border-white/15 hover:border-[#10B981] hover:text-[#10B981] transition-colors"><Youtube size={14} /></a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-white/40">
          <div>Copyright © Clinivon. All Rights Reserved.</div>
          <div>Built for measurable outcomes.</div>
        </div>
      </div>
    </footer>
  );
}
